import type { CoreData } from '../types';

// Apollo doesn't provide a nice API to distinguish whether or not query hits cache.
// If we naively measure performance for consecutive requests, it will measure duration including queries that hit caches,
// which will pollute our data. Therefore, we will only monitor initial load for now until we find a solution.
let isInitial = true;
export const isInitialLoad = (): boolean => isInitial;
export const setInitialLoadFinished = () => {
	isInitial = false;
};

export const collectorFromNumIssues = ({
	numIssues,
	deploymentsPageSize,
	issuePageSize,
}: {
	numIssues: number;
	deploymentsPageSize: number;
	issuePageSize: number;
}) => ({
	numIssues,
	deploymentsPageSize,
	issuePageSize,
});

export const collectorFromNumIssuesDeployments = ({
	numIssues,
	numDeployments,
	deploymentsPageSize,
	issuePageSize,
}: {
	numIssues: number;
	numDeployments: number;
	deploymentsPageSize: number;
	issuePageSize: number;
}) => ({
	numIssues,
	numDeployments,
	deploymentsPageSize,
	issuePageSize,
});

export const collectorFromCoreData = ({
	coreData,
	deploymentsPageSize,
	issuePageSize,
}: {
	coreData: CoreData;
	deploymentsPageSize: number;
	issuePageSize: number;
}) => ({
	numIssues: coreData.issues.length,
	numDeployments: coreData.allDeployments.length,
	deploymentsPageSize,
	issuePageSize,
});
